var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticStyle:{"position":"relative","overflow":"hidden"}},[_c('notif-container'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }